<div
    class="input-password-form__box"
    [class.invalid]="submitted && passwordControl.errors && (
        passwordControl.errors['required'] ||
        passwordControl.errors['pattern'] ||
        !!invalid
    )"
    [class.readonly]="readonly"
>
    <div class="input-password-form__name" *ngIf="labelName">
        {{labelName | translate}}
        <span *ngIf="isRequired">*</span>
    </div>

    <input
        [name]="name"
        [id]="id"
        [placeholder]="placeholder ? placeholder : ''"
        [formControl]="passwordControl"
        [type]="isPasswordShow ? 'text' : 'password'"
        [attr.tabindex]="tabindex ?? null"
        [autocomplete]="autocomplete"
    />
    <div
        class="input-password-form__eye iconsax"
        [iconName]="isPasswordShow ? 'eye-slash' : 'eye'"
        (click)="isPasswordShow = !isPasswordShow"
    ></div>
</div>
